import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Link from 'flarum/common/components/Link';
import Icon from 'flarum/common/components/Icon';
import RelatedDiscussionsList from './components/RelatedDiscussionsList';
export default function () {
  let relatedDiscussionsListInstance;

  // afterFirstPostItems() renders directly below the first post — core's own
  // seam for exactly this placement, so no vdom surgery is needed.
  extend('flarum/forum/components/PostStream', 'afterFirstPostItems', function (items) {
    const discussion = this.discussion;
    if (!discussion || discussion.isPrivateDiscussion?.()) {
      return;
    }
    items.add('relatedDiscussionsLink', m(Link, {
      href: "#related-discussion-list",
      className: "RelatedDiscussionsLink Button",
      onclick: evt => {
        evt.preventDefault();
        relatedDiscussionsListInstance?.show();
      }
    }, app.translator.trans('glowingblue-related.forum.discussion_page.related_link'), " ", m(Icon, {
      name: "fas fa-chevron-down"
    })));
  });

  // endItems() is PostStream's own seam for appending to the end of the stream.
  extend('flarum/forum/components/PostStream', 'endItems', function (items) {
    const discussion = this.discussion;
    if (!discussion || discussion.isPrivateDiscussion?.()) {
      return;
    }
    items.add('relatedDiscussions', m(RelatedDiscussionsList, {
      key: "relatedDiscussions",
      discussion: discussion,
      setInstance: instance => relatedDiscussionsListInstance = instance
    }), -100);
  });
}